// src/features/reference-ncs/ChercheurNcs.tsx — SCE Issues
// Monté une fois (App.tsx) : écoute chaque liste de problèmes chargée
// (`annoncerProblemesCharges`, émis par useIssues) et lance en fond la
// recherche des N° de NC-S manquants (chercheur.ts), puis la mise à jour de
// leur suivi par la qualité (`actualiserSuiviNcs`, instantané partagé). Un N° écrit → les
// listes montées se relisent en silence, le badge affiche le N°.
//
// Pas pour un fournisseur (registre qualité hors périmètre), ni en bascule de
// rôle (rien ne s'écrit tout seul sous le compte réel pendant qu'on regarde
// avec les yeux d'un autre).

import { useEffect } from 'react'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useVueRole } from '@/features/vue-role/contexte'
import { signalerProblemesModifies } from '@/hooks/signalProblemesModifies'
import { EVENEMENT_PROBLEMES_CHARGES } from '@/hooks/useIssues'
import type { Issue } from '@/types/issue.types'
import { publierSuiviNcs } from '@/hooks/useSuiviNcs'
import { actualiserSuiviNcs, chercherNumerosManquants, enAttenteDeNumero } from './chercheur'

export function ChercheurNcs(): null {
  const { isFournisseur, user } = useCurrentUser()
  const { profil } = useVueRole()
  const actif = !!user && !isFournisseur && profil === null

  useEffect(() => {
    if (!actif) return
    function surListe(e: Event): void {
      const issues = (e as CustomEvent<readonly Issue[]>).detail
      if (!issues) return
      if (enAttenteDeNumero(issues).length > 0) {
        void chercherNumerosManquants(issues).then((ecrits) => {
          if (ecrits > 0) signalerProblemesModifies()
        })
      }
      // Où en sont les NC-S chez la qualité (badge de la fiche, 06/10).
      void actualiserSuiviNcs(issues).then((bloc) => {
        if (bloc) publierSuiviNcs(bloc)
      })
    }
    window.addEventListener(EVENEMENT_PROBLEMES_CHARGES, surListe)
    return () => window.removeEventListener(EVENEMENT_PROBLEMES_CHARGES, surListe)
  }, [actif])

  return null
}
